import { Chip, ChipBackgroundColor, ChipIconPosition, ChipSize } from "@amzn/stencil-react-components/chip";
import { Text } from "@amzn/stencil-react-components/text";
import { withTooltip } from "@amzn/stencil-react-components/tooltip";
import { IconSize } from "@amzn/stencil-react-icons";
import IconInformationFill from "@amzn/stencil-react-icons/icons/icon-information-fill";
import { getString } from "common/uistringlabels/uiStringUtils";
import React from "react";

const STRING_PATH = "foundational";

export const FoundationalChip = () => {
  const IconInformationFillToolTip = withTooltip()(IconInformationFill);

  return (
    <Chip
      backgroundColor={ChipBackgroundColor.Green}
      icon={
        <IconInformationFillToolTip
          title="Show tooltip"
          tooltipText={getString(`${STRING_PATH}.toolTipText`)}
          size={IconSize.ExtraSmall}
        />
      }
      iconPosition={ChipIconPosition.Leading}
      size={ChipSize.ExtraSmall}
      dataTestId="catalog-product-value-pick"
    >
      <Text className="value-chip">{getString(`${STRING_PATH}.chipText`)}</Text>
    </Chip>
  );
};
